import * as yup from 'yup';
import moment from 'moment';

// Utilities

import { isRif } from '../../../../utilities/validations.helper-functions';

// Constants

import { DUE_DILIGENCE_SPECIAL_CATEGORIES, NAMES_VALIDATION_REGEX, SOCIAL_MEDIA_USERNAME_VALIDATION_REGEX } from '../../../../config/constants';

export const validationSchema = [
  yup.object().shape({
    cliente: yup.object().shape({
      nombre: yup.string().required('Este campo es requerido').test("nombreTest", "Nombre sin acentos o caracteres especiales", function (value) {
        return NAMES_VALIDATION_REGEX?.test(value);
      }),
      primerApellido: yup.string().required('Este campo es requerido').test("primerApellidoTest", "Apellido sin acentos o caracteres especiales", function (value) {
        return NAMES_VALIDATION_REGEX?.test(value);
      }),
      segundoApellido: yup.string().test("segundoApellidoTest", "Apellido sin acentos o caracteres especiales", function (value) {
        return NAMES_VALIDATION_REGEX?.test(value);
      }),
      fechaNacimiento: yup.string().required('Este campo es requerido'),
      tipoDocumento: yup.string().required('Este campo es requerido'),
      cedulaRif: yup.string().when("tipoDocumento", {
        is: (val) => val !== 'P' && val !== undefined && val !== '',
        then: yup.string().required('Este campo es requerido').test("cedulaTest", "Número de identificación no puede iniciar con 0.", function (value) {
          return value?.charAt(0) !== '0';
        }),
        otherwise: yup.string(),
      }),
      pasaporte: yup.string().when("tipoDocumento", {
        is: (val) => val === 'P',
        then: yup.string().required('Este campo es requerido').test('pasaporteTest', 'Pasaporte de al menos 5 caracteres', val => val?.length >= 5),
        otherwise: yup.string(),
      }),
      esMenorDeEdad: yup.boolean(),
      fechaExpedicionIdentificacion: yup.string().required('Este campo es requerido'),
      fechaVenceIdentificacion: yup.string().required('Este campo es requerido'),
      sexo: yup.string().required('Este campo es requerido'),
      tipoRif: yup.string().when("esMenorDeEdad", {
        is: (val) => val === false,
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      rif: yup.string().when("esMenorDeEdad", {
        is: (val) => val === false,
        then: yup.string().required('Este campo es requerido').test("validacionRif", "Por favor ingrese un rif válido.", function (value) {
          if (this.parent.tipoRif === "P") {
            return true;
          }
          if (this.parent.tipoRif && value) {
            return isRif(this.parent.tipoRif + value, this.parent.nacionalidad);
          } else {
            return false;
          }
        }),
        otherwise: yup.string(),
      }),
      nacionalidad: yup.string().required('Este campo es requerido'),
      codigoOtraNacionalidad: yup.string(),
      lugarNacimiento: yup.string().required('Este campo es requerido'),
      estadoNacimiento: yup.string().when("lugarNacimiento", {
        is: (val) => val === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      ciudadNacimiento: yup.string().when("lugarNacimiento", {
        is: (val) => val === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      cargaFamiliar: yup.number().when("cliente.tipoCliente", {
        is: (val) => ['1', '2', '5', '6'].includes(val),
        then: yup.number().required('Este campo es requerido').typeError('Favor ingresar un número'),
        otherwise: yup.number().typeError('Favor ingresar un número'),
      }),
      estadoCivil: yup.string().required('Este campo es requerido'),
      tipoCliente: yup.string().required('Este campo es requerido').test("validacionMenor", "Esta condición no aplica para su edad.", function (value) {
        const currentDate = moment();
        const birthDate = moment(this.parent.fechaNacimiento);
        const dateDifference = currentDate.diff(birthDate, 'year');

        if ((value === '4' || value === '3') && dateDifference >= 18) {
          return false;
        } else if ((value !== '4' && value !== '3') && dateDifference < 18) {
          return false;
        } else {
          return true;
        }
      }),
      caracteristicaCliente: yup.string().when("cliente.tipoCliente", {
        is: (val) => ['1', '2', '6'].includes(val),
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      profesion: yup.string().required('Este campo es requerido'),
      actividadEspecifica: yup.string().required('Este campo es requerido'),
      actividadEconomica: yup.string().required('Este campo es requerido'),
      categoriaEspecial: yup.string().required('Este campo es requerido'),
      nivelAcademico: yup.string().required('Este campo es requerido'),

      actividadGeneradoraIngreso: yup.string().when("cliente.tipoCliente", {
        is: (val) => ['5', '6'].includes(val),
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      fechaDesdeCuandoRecibeIngreso: yup.string().when("cliente.tipoCliente", {
        is: (val) => ['5', '6'].includes(val),
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      tipodeMonedaIngreso: yup.string().when("cliente.tipoCliente", {
        is: (val) => ['5', '6'].includes(val),
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      montoEstimadoDeIngreso: yup.string().when("cliente.tipoCliente", {
        is: (val) => ['5', '6'].includes(val),
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      descripcionDeIngreso: yup.string().when("cliente.tipoCliente", {
        is: (val) => ['5', '6'].includes(val),
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      incomeIsValid: yup
      .boolean()
      .nullable()
      .when("tipoCliente", {
        is: (val) => ['5', '6'].includes(val),
        then: (schema) =>
          schema.test(
            "incomeIsValidTest",
            "Por favor valide el ingreso antes de continuar.",
            value => value === true
          ),
        otherwise: (schema) => schema.nullable(),
      }),
    }),
    dueDiligence: yup.string().when("cliente.categoriaEspecial", {
      is: (val) => DUE_DILIGENCE_SPECIAL_CATEGORIES?.includes(val),
      then: yup.string().required('Este campo es requerido'),
      otherwise: yup.string(),
    }),
    conyuge: yup.object().when('cliente.estadoCivil', {
      is: (val) => val == 'C' || val == 'U',
      then: yup.object().shape({
        nombre: yup.string().required('Este campo es requerido').test("nombreTest", "Nombre sin acentos o caracteres especiales", function (value) {
          return NAMES_VALIDATION_REGEX?.test(value);
        }),
        primerApellido: yup.string().required('Este campo es requerido').test("primerApellidoTest", "Apellido sin acentos o caracteres especiales", function (value) {
          return NAMES_VALIDATION_REGEX?.test(value);
        }),
        segundoApellido: yup.string().test("segundoApellidoTest", "Apellido sin acentos o caracteres especiales", function (value) {
          return NAMES_VALIDATION_REGEX?.test(value);
        }),
        tipoDocumento: yup.string().required('Este campo es requerido'),
        cedulaRif: yup.string().when("tipoDocumento", {
          is: (val) => val !== 'P' && val !== undefined && val !== '',
          then: yup.string().required('Este campo es requerido').test("cedulaTest", "Número de identificación no puede iniciar con 0.", function (value) {
            return value?.charAt(0) !== '0';
          }),
          otherwise: yup.string(),
        }),
        pasaporte: yup.string().when("tipoDocumento", {
          is: (val) => val === 'P',
          then: yup.string().required('Este campo es requerido').test('pasaporteTest', 'Pasaporte de al menos 5 caracteres', val => val?.length >= 5),
          otherwise: yup.string(),
        }),
        fechaVenceIdentificacion: yup.string().required('Este campo es requerido'),
        fuenteOrigen: yup.string().required('Este campo es requerido'),
      }),
    }),
    hasApoderado: yup.string().required('Este campo es requerido'),
    apoderado: yup.object().when('hasApoderado', {
      is: (val) => val === 'si',
      then: yup.object().shape({
        nombre: yup.string().required('Este campo es requerido').test("nombreTest", "Nombre sin acentos o caracteres especiales", function (value) {
          return NAMES_VALIDATION_REGEX?.test(value);
        }),
        primerApellido: yup.string().required('Este campo es requerido').test("primerApellidoTest", "Apellido sin acentos o caracteres especiales", function (value) {
          return NAMES_VALIDATION_REGEX?.test(value);
        }),
        segundoApellido: yup.string().test("segundoApellidoTest", "Apellido sin acentos o caracteres especiales", function (value) {
          return NAMES_VALIDATION_REGEX?.test(value);
        }),
        fechaNacimiento: yup.string().required('Este campo es requerido'),
        tipoDocumento: yup.string().required('Este campo es requerido'),
        cedulaRif: yup.string().when("tipoDocumento", {
          is: (val) => val !== 'P' && val !== undefined && val !== '',
          then: yup.string().required('Este campo es requerido').test("cedulaTest", "Número de identificación no puede iniciar con 0.", function (value) {
            return value?.charAt(0) !== '0';
          }),
          otherwise: yup.string(),
        }),
        pasaporte: yup.string().when("tipoDocumento", {
          is: (val) => val === 'P',
          then: yup.string().required('Este campo es requerido').test('pasaporteTest', 'Pasaporte de al menos 5 caracteres', val => val?.length >= 5),
          otherwise: yup.string(),
        }),
        fechaVenceIdentificacion: yup.string().required('Este campo es requerido'),
        pais: yup.string().required('Este campo es requerido'),
        descDireccion: yup.string().when("pais", {
          is: (val) => val !== '0',
          then: yup.string().required('Este campo es requerido'),
          otherwise: yup.string(),
        }),
        entidad: yup.string().when("pais", {
          is: (val) => val === '0',
          then: yup.string().required('Este campo es requerido'),
          otherwise: yup.string(),
        }),
        ciudad: yup.string().when("pais", {
          is: (val) => val === '0',
          then: yup.string().required('Este campo es requerido'),
          otherwise: yup.string(),
        }),
        municipio: yup.string().when("pais", {
          is: (val) => val === '0',
          then: yup.string().required('Este campo es requerido'),
          otherwise: yup.string(),
        }),
        parroquia: yup.string().when("pais", {
          is: (val) => val === '0',
          then: yup.string().required('Este campo es requerido'),
          otherwise: yup.string(),
        }),
        urbanizacion: yup.string().when("pais", {
          is: (val) => val === '0',
          then: yup.string().required('Este campo es requerido'),
          otherwise: yup.string(),
        }),
        calle: yup.string().when("pais", {
          is: (val) => val === '0',
          then: yup.string().required('Este campo es requerido'),
          otherwise: yup.string(),
        }),
        identificacionRegistro: yup.string().required('Este campo es requerido'),
        numeroRegistro: yup.string().required('Este campo es requerido'),
        tomoRegistro: yup.string().required('Este campo es requerido'),
        protocolo: yup.string().required('Este campo es requerido'),
        fechaRegistro: yup.string().required('Este campo es requerido'),
      }),
    }),
  }),
  yup.object().shape({
    direccion: yup.object().shape({
      pais: yup.string().required('Este campo es requerido'),
      descDireccion: yup.string().when("pais", {
        is: (val) => val !== '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      entidad: yup.string().when("pais", {
        is: (val) => val === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      ciudad: yup.string().when("pais", {
        is: (val) => val === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      municipio: yup.string().when("pais", {
        is: (val) => val === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      parroquia: yup.string().when("pais", {
        is: (val) => val === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      urbanizacion: yup.string().when("pais", {
        is: (val) => val === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      callecarretera: yup.string().when("pais", {
        is: (val) => val === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      calle: yup.string(),
      avenida: yup.string(),
      esquina: yup.string(),
      observaciones: yup.string().when("pais", {
        is: (val) => val === '0',
        then: yup.string(),
        otherwise: yup.string(),
      }),
      tipoInmueble: yup.string().when("pais", {
        is: (val) => val === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      nombreInmueble: yup.string().when("pais", {
        is: (val) => val === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      nivel: yup.string().when(["pais", "tipoInmueble"], {
        is: (pais, tipoInmueble) => (tipoInmueble === '1' || tipoInmueble === '2') && pais === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      torre: yup.string().when(["pais", "tipoInmueble"], {
        is: (pais, tipoInmueble) => (tipoInmueble === '3' || tipoInmueble === '5') && pais === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      piso: yup.string().when(["pais", "tipoInmueble"], {
        is: (pais, tipoInmueble) => (tipoInmueble === '3' || tipoInmueble === '5') && pais === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
      apartamento: yup.string().when(["pais", "tipoInmueble"], {
        is: (pais, tipoInmueble) => (tipoInmueble === '3' || tipoInmueble === '5') && pais === '0',
        then: yup.string().required('Este campo es requerido'),
        otherwise: yup.string(),
      }),
    }).test(
      "at-least-one-direccion-field",
      "Debe completar al menos uno: avenida, calle o esquina",
      function (value) {
        if (!value) return false;

        const { avenida, calle, esquina, pais } = value;

        // Solo aplica cuando pais === '0'
        if (pais !== '0') return true;

        const hasOne =
          (avenida && avenida.trim() !== "") ||
          (calle && calle.trim() !== "") ||
          (esquina && esquina.trim() !== "");

        if (hasOne) return true;

        // esto hace que el error aparezca en un campo específico
        return this.createError({
          path: "direccion._direccionGroup",
          message: "Debe completar al menos uno: avenida, calle o esquina",
        });
      }
    ),
    cliente: yup.object().shape({
      condicionVivienda: yup.string().required('Este campo es requerido'),
      fechaDesde: yup.number().required('Este campo es requerido').typeError('Favor ingresar un número'),
    }),
    socialMediaLinks: yup.array().of(
      yup.object({
        tipoDireccion: yup.string(),
        descripcionDireccion: yup.string().when("tipoDireccion", {
          is: (val) => val === 'M',
          then: yup.string().email('Ingrese un email válido.').required('Este campo es requerido'),
          otherwise: yup.string().test("socialLinkTest", "Por favor ingrese una dirección (sin caracteres especiales)", function (value) {
            if (!value && !this.parent.tipoDireccion) {
              return true;
            } else if (value && this.parent.tipoDireccion && SOCIAL_MEDIA_USERNAME_VALIDATION_REGEX?.test(value)) {
              return true;
            } else {
              return false;
            }
          }),
        }),
      }),
    ),
  }),
  yup.object().shape({
    cliente: yup.object().shape({
      mail: yup.string().email('Ingrese un email válido.').required('Este campo es requerido'),
    }),
    direccion: yup.object().shape({
      telefono1: yup.object({
        tipo: yup.string().required('Este campo es requerido'),
        codigoArea: yup.string().when("pais", {
          is: (val) => val === '0',
          then: yup.string().required('Este campo es requerido'),
          otherwise: yup.string().required('Este campo es requerido').min(1, 'Digite el código de area completo'),
        }),
        numero: yup.string().when("pais", {
          is: (val) => val === '0',
          then: yup.string().required('Este campo es requerido').length(7, 'Digite el teléfono completo'),
          otherwise: yup.string().required('Este campo es requerido').min(7, 'El teléfono debe tener al menos 7 dígitos'),
        }),
      }),
      telefono2: yup.object({
        tipo: yup.string().test("telTypeTest", "Complete todos los campos de teléfono", function (value) {
          if (!this.parent.codigoArea && !this.parent.numero && !value) {
            return true;
          } else if (this.parent.codigoArea && this.parent.numero && value) {
            return true;
          } else {
            return false;
          }
        }),
        codigoArea: yup.string().when("pais", {
          is: (val) => val === '0',
          then: yup.string().test("telAreaSelectTest", "Complete todos los campos de teléfono", function (value) {
            if (!this.parent.tipo && !this.parent.numero && !value) {
              return true;
            } else if (this.parent.tipo && this.parent.numero && value) {
              return true;
            } else {
              return false;
            }
          }),
          otherwise: yup.string().min(1, 'Digite el código de area completo').test("telAreaTextTest", "Complete todos los campos de teléfono", function (value) {
            if (!this.parent.tipo && !this.parent.numero && !value) {
              return true;
            } else if (this.parent.tipo && this.parent.numero && value) {
              return true;
            } else {
              return false;
            }
          }),
        }),
        numero: yup.string().when("pais", {
          is: (val) => val === '0',
          then: yup.string().min(7, 'Digite el teléfono completo').test("telNumberTest", "Complete todos los campos de teléfono", function (value) {
            if (!this.parent.tipo && !this.parent.codigoArea && !value) {
              return true;
            } else if (this.parent.tipo && this.parent.codigoArea && value) {
              return true;
            } else {
              return false;
            }
        }),
          otherwise: yup.string().min(7, 'El teléfono debe tener al menos 7 dígitos').test("telNumberTest", "Complete todos los campos de teléfono", function (value) {
            if (!this.parent.tipo && !this.parent.codigoArea && !value) {
              return true;
            } else if (this.parent.tipo && this.parent.codigoArea && value) {
              return true;
            } else {
              return false;
            }
          }),
        }),
      }),
    }),
  })
];